const Editor = toastui.Editor;
// Step 1: Define the user plugin function
function youtubePlugin() {
  Editor.codeBlockManager.setReplacer('youtube', function(youtubeId) {
    // Indentify multiple code blocks
    const wrapperId = `yt${Math.random()
      .toString(36)
      .substr(2, 10)}`;

    // Avoid sanitizing iframe tag
    setTimeout(renderYoutube.bind(null, wrapperId, youtubeId), 0);

    return `<div id="${wrapperId}"></div>`;
  });
}

function renderYoutube(wrapperId, youtubeId) {
		const el = document.querySelector(`#${wrapperId}`);
		el.innerHTML = `<iframe width="420" height="315" src="https://www.youtube.com/embed/${youtubeId}"></iframe>`;
}

mtggoldfishImagesPluginCache = {};

// Step 1: Define the user plugin function
function mtggoldfishImagesPlugin() {
  Editor.codeBlockManager.setReplacer('images', function(images) {
    // Indentify multiple code blocks
    const wrapperId = `yt${Math.random()
      .toString(36)
      .substr(2, 10)}`;

    // Avoid sanitizing iframe tag
    setTimeout(renderImages.bind(null, wrapperId, images), 0);

    return `<div id="${wrapperId}"></div>`;
  });
}

function renderImages(wrapperId, images) {
  const el = document.querySelector(`#${wrapperId}`);
  const id = `yt${Math.random()
    .toString(36)
    .substr(2, 10)}`;

  if (images in mtggoldfishImagesPluginCache) {
    el.innerHTML = mtggoldfishImagesPluginCache[images];
  } else {
    fetch('/widgets/cards_container?' + new URLSearchParams({cards: images})).then(response => response.json()
    ).then(data => {
      mtggoldfishImagesPlugin[images] = data.data;
      el.innerHTML = data.data;
    });
  }
}

var map = {}

function htmlForCard(map, card) {
	if (card in map) {
		return map[card];
	} else {
		return card;
	}
}

function replacer(match, p1, offset, string) {
	if (p1 in map) {
		return map[p1];
	} else {
		return `[[${p1}]]`;
	}
}

// Returns all text nodes within el, skipping iframes
var getTextNodesIn = function(el) {
  var textNodes = [];
  function walk(node) {
    if (node.tagName === 'IFRAME') return;
    if (node.nodeType === 3) {
      textNodes.push(node);
    } else {
      Array.from(node.childNodes).forEach(walk);
    }
  }
  walk(el);
  return textNodes;
};

function replaceTextNodeWithHtml(node, html) {
  var temp = document.createElement('span');
  temp.innerHTML = html;
  var fragment = document.createDocumentFragment();
  while (temp.firstChild) fragment.appendChild(temp.firstChild);
  node.parentNode.replaceChild(fragment, node);
}

function createHTMLElement(string) {
	var div = document.createElement("div");
	div.innerHTML = string;
	return div.firstChild;
}


window.MTGGoldfish = window.MTGGoldfish || {};
window.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.onDocumentReadyArray.push(function() {

  var editorEl = document.getElementById('editor');
  if (editorEl) {
    var descriptionEl = document.getElementById('deck-description');
    const editor = new Editor({
      el: editorEl,
      height: '500px',
      initialEditType: 'markdown',
      previewStyle: 'vertical',
      initialValue: descriptionEl ? descriptionEl.value : '',
      usageStatistics: false,
      hideModeSwitch: true,
			toolbarItems: [
				'heading',
				'bold',
				'italic',
				'strike',
				'divider',
				'hr',
				'quote',
				'divider',
				'ul',
				'ol',
				'task',
				'divider',
				'table',
			],
      plugins: [youtubePlugin, mtggoldfishImagesPlugin],
    });

    editor.eventManager.listen('previewRenderAfter', ev => {
      var root = document.querySelector(".te-preview");
      if (!root) return;
      var text = root.textContent;
      var regex = /\[\[(.*?)\]\]/g;
      var cards = text.match(regex);

      if (cards) {
        cards = cards.map(x => x.replace(/^\[\[/, "").replace(/\]\]$/, ""))
        params = new URLSearchParams();
        cards = cards.filter(card => !(card in map))

        if (cards.length > 0) {
          cards.forEach(c => { params.append("cards[]", c); });
          fetch('/widgets/article_link?' + params).then(response => response.json()
          ).then(data => {
            map = {...map, ...data};
            getTextNodesIn(root).forEach(function(node) {
              if (node.textContent.match(regex)) {
                replaceTextNodeWithHtml(node, node.textContent.replace(regex, replacer));
              }
            });
            bindPopover();
          });
        } else {
          getTextNodesIn(root).forEach(function(node) {
            if (node.textContent.match(regex)) {
              replaceTextNodeWithHtml(node, node.textContent.replace(regex, replacer));
            }
          });
          bindPopover();
        }
      }
    });

    var formEl = document.getElementById("new_deck_input");
    if (formEl) {
      formEl.addEventListener('submit', function() {
        if (descriptionEl) descriptionEl.value = editor.getMarkdown();
      });
    }
  }

});
